module.exports = "<div class=\"loading\">\n  <div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n    <md-progress-circular\n      class=\"md-accent md-hue-1\"\n      md-diameter=\"60\"\n      md-mode=\"indeterminate\"\n    ></md-progress-circular>\n  </div>\n  <p ng-if=\"$ctrl.hasLoadingText || $ctrl.text\" class=\"loading__msg\">\n    {{ $ctrl.text ? $ctrl.text : 'Loading...' }}\n  </p>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/loadingSpinner/loadingSpinner.html
// module id = 1118
// module chunks = 0